<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent">I have been so fortunate in my friends and colleagues that it is impossible to list all who have helped me locate stories, participated in interviews and trips or offered an encouraging cup of coffee during a long night of ghost writing. Some people wished to remain anonymous, but you know who you are, and you know you have my deepest appreciation.</p>
<p class="indent">I wish especially to thank the following people for their encouragement and support: the Baa Baa Boonville Hookers (Janet Acton, Sara Arrandale, Elinor Barrett, Susan Meadows and Karen Neely), Margaret Barile, James Cogswell, Deb Entwistle, Susan Fales, Susan Flader, Arlene Hoose, Brett Johnson, Ryan McNeil, Christine Montgomery, Phebe Nichols, Diane and Fred Oerly, Greg Olson, Nan Presser, Lucille Salerno, Matt Saltzberg, Jill Sappington, Jennie and David Schutte, Gena Scott, Mike Shaw, Betty Sieckmann and Richard Wallace.</p>
<p class="indent">The following groups were also gracious with their help and their time: the Friends of Historic Boonville, the Columbia Paranormal Society, Beth Meyer and Paranormal Adventures USA, the Springfield Paranormal Research Group, the State Historical Society of Missouri, Ellis Library at the University of Missouri and the Jefferson City Tourism Bureau, including Steve Picker and Marie Lacey.</p>
<p class="indent">Tess Montgomery provided several photographs for this book.</p>
<p class="indent">Special thanks to Ben Gibson and the folks at The History Press who took on this project with enthusiasm and helped me with their patience, talent and experience.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgement.vue?237ad21d